import { useLandingVideo } from 'App/Providers/games/LandingVideoProvider';

import lpThumbnail from '../../../../../assets/lp-thumbnail.png';
import polyglot from '../../../../../localization';

import './styles.scss';

/**
 * Phone mockup with the shared LandingVideoProvider slot, or a fallback
 * inline video when the provider did not expose a hero slot ref.
 *
 * @param {string} lang — Language key for the thumbnail alt text.
 * @param {string} [videoUrl] — LP video URL used only without a shared slot.
 */
export const LightningHeroPhone = ({ lang, videoUrl }) => {
    const { heroSlotRef } = useLandingVideo() || {};
    const useSharedSlot = Boolean(heroSlotRef);

    return (
        <div className='lightning-hero-phone'>
            <div className='lightning-hero-phone__device' />
            <img
                src={lpThumbnail}
                width={186}
                height={404}
                className='lightning-hero-phone__thumbnail'
                alt={polyglot.t(`${lang}.hero.alt.defaultVideo`)}
                fetchPriority='high'
            />

            {useSharedSlot && (
                <div ref={heroSlotRef} className='lightning-hero-phone__video' />
            )}

            {!useSharedSlot && videoUrl && (
                <div className='lightning-hero-phone__video'>
                    <video
                        src={videoUrl}
                        autoPlay={true}
                        muted={true}
                        width='auto'
                        height='100%'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;'
                        playsInline
                        loop
                    />
                </div>
            )}
        </div>
    );
};
